module.exports = "<p>\r\n  model3d-help works!\r\n</p>\r\n"